import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import * as queryString from 'querystring'
import isEmpty from 'lodash/isEmpty'
import { css, StyleSheet } from 'aphrodite'
import cn from 'classnames'
import { useLoad, usePostRequest } from '../hooks/request'
import Layout from '../components/Layout/Layout'
import { CLIENT_LIST, SEND_MESSAGE_SELECT, TOTAL_BORROW_LIST } from '../urls'
import { useModal } from '../hooks/modal'
import { useQueryParams } from '../hooks/queryString'
import Table from '../components/common/Table'
import BorrowItem from '../components/BorrowItem'
import ClientCreate from '../components/ClientCreate'
import { useMessage } from '../hooks/message'
import { format } from '../utils/number'
import { checkPermission as cp } from '../utils/auth'
import { PermissionDenied } from '../components/PermissionDenied'

export default function Borrow() {
    const params = useQueryParams()
    const history = useHistory()
    const [page, setPage] = useState(1)
    const clients = useLoad({
        url: CLIENT_LIST,
        params: { page, ...params },
    }, [params, page])
    const productList = clients.response ? clients.response.results : []

    const [showCreateModal, setShowCreateModal] = useModal(
        <ClientCreate
            clients={clients}
            onCancel={() => setShowCreateModal()}
        />,
    )

    function onSearch(query) {
        const search = !isEmpty(query) ? query : undefined
        history.push(`?${queryString.stringify({ ...params, search })}`)
    }
    const [checkedItems, setCheckedItems] = useState([])
    const handleCheckboxChange = (itemId, isChecked) => {
        setCheckedItems((prevState) => {
            if (isChecked) {
                return [...prevState, itemId]
            }
            return prevState.filter((id) => id !== itemId)
        })
    }
    const [showMessage] = useMessage()
    const send = usePostRequest({ url: SEND_MESSAGE_SELECT })
    async function onSend() {
        const { success } = await send.request({ data: { client_ids: checkedItems } })
        if (success) {
            showMessage('Сизнинг sms хабарингиз муваффақиятли юборилди', 'is-success')
            setCheckedItems([])
            clients.request()
        }
    }

    const total = useLoad({
        url: TOTAL_BORROW_LIST,
        params: { ...params },
    })

    if (!cp('READ')) {
        return <PermissionDenied />
    }
    return (
        <Layout onSearch={onSearch} onSend={onSend} showCreateModal={showCreateModal}>
            <div className={cn(css(styles.table), 'box mb-2')}>
                <div className={cn(css(styles.tableItem), '')}>
                    <Table
                        loading={clients.loading}
                        items={productList}
                        columns={{
                            name: 'Имя',
                            address: 'Номер телефона',
                            price: 'Цена',
                            actisadons: 'Выберите',
                            actidssadons: 'Последней отправки',
                            action: '',
                        }}
                        totalCount={clients.response ? clients.response.count : 0}
                        pageSize={15}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item) => (
                            <BorrowItem
                                onCheckboxChange={handleCheckboxChange}
                                clients={clients}
                                products={clients}
                                key={item.id}
                                item={item}
                            />
                        )} />
                </div>

            </div>
            <div className="box">
                <p className="is-capitalized">все долги:
                    <span
                        className="ml-2 has-text-danger">{format(total.response ? total.response.totalAmount : 0)} сум
                    </span>
                </p>
            </div>
        </Layout>
    )
}
const styles = StyleSheet.create({
    table: {
        '@media (max-width: 500px)': {
            overflowX: 'scroll',
        },
    },
    tableItem: {
        '@media (max-width: 500px)': {
            width: 800,
        },
    },
    br: {
        '@media (max-width: 500px)': {
            width: 800,
        },
    },
})
